import * as React from 'react';
import type { SVGProps } from 'react';
const SvgProtectedFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    viewBox="0 0 28.0001 35.9996"
    fill="none"
    {...props}
  >
    <path
      d="M4.37598 0.5H10.5C11.1586 0.500119 11.9396 0.804411 12.5771 1.30664C13.2187 1.81207 13.6296 2.44808 13.6797 3.04199L13.6826 3.08105L13.6924 3.11914L15.1494 9.08105C15.2251 9.89828 15.3075 10.5682 15.4434 11.1084C15.5825 11.6616 15.7884 12.1223 16.1406 12.4814C16.4937 12.8413 16.9474 13.0521 17.4912 13.1943C18.0247 13.3338 18.686 13.4179 19.4893 13.4961L25.3379 14.4932L25.3564 14.4961L25.374 14.498C25.8898 14.5479 26.4189 14.9698 26.8428 15.6816C27.2578 16.3788 27.4999 17.2414 27.5 17.9473V31.5C27.4999 33.7059 25.7355 35.5 23.625 35.5H4.375C2.26174 35.4998 0.500144 33.7109 0.5 31.5V4.49902C0.500186 2.35646 2.15091 0.611702 4.17871 0.504883L4.37598 0.5Z"
      fill="white"
      stroke="#CBCCD7"
    />
    <path
      d="M13.3591 1.51758C13.8521 1.8093 14.3779 2.15621 14.9265 2.55176C16.7217 3.84624 18.7279 5.62631 20.6071 7.5498C22.4864 9.47333 24.2257 11.5277 25.4909 13.3662C25.8834 13.9366 26.2273 14.4831 26.5153 14.9951C26.1487 14.8221 25.7506 14.7037 25.3347 14.6523V14.6514H25.3269C25.2836 14.6467 25.2427 14.6419 25.1999 14.6377H25.195L18.6638 14.0537H18.6628C17.0754 13.9122 16.081 13.5312 15.4392 12.874C14.7951 12.2143 14.4211 11.1897 14.2819 9.56055L13.7312 3.10547H13.7321L13.7126 2.87402C13.6717 2.39582 13.5496 1.93624 13.3591 1.51758Z"
      fill="white"
      stroke="#CBCCD7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 16.5C12.1591 16.5 10.6667 17.9924 10.6667 19.8333V21H9.83335C9.18902 21 8.66668 21.5223 8.66668 22.1667V28.5C8.66668 29.1443 9.18902 29.6667 9.83335 29.6667H18.1667C18.811 29.6667 19.3333 29.1443 19.3333 28.5V22.1667C19.3333 21.5223 18.811 21 18.1667 21H17.3333V19.8333C17.3333 17.9924 15.841 16.5 14 16.5ZM16.3333 21V19.8333C16.3333 18.5447 15.2887 17.5 14 17.5C12.7114 17.5 11.6667 18.5447 11.6667 19.8333V21H16.3333ZM14 23.8333C14.2762 23.8333 14.5 24.0572 14.5 24.3333V26.3333C14.5 26.6095 14.2762 26.8333 14 26.8333C13.7239 26.8333 13.5 26.6095 13.5 26.3333V24.3333C13.5 24.0572 13.7239 23.8333 14 23.8333Z"
      fill="#454655"
    />
  </svg>
);
export default SvgProtectedFile;
